import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Users } from 'lucide-react'

import { confirmationKeys, dealConfirmation } from '@/services/dealConfirmation'
import { ConfirmationViewDialog } from './ConfirmationView'
import { ConfirmationViewQueueDialog } from './ConfirmationViewQueue'

/**
 * The Intake page's way into the manager queue.
 *
 * Draws nothing unless the administrator has switched the step on AND this
 * account can approve — an account that cannot act on the queue is not shown a
 * button that opens an explanation. The count is the number waiting, so a
 * manager sees there is work without opening it.
 */
export function ManagerQueueButton() {
  const queue = useQuery({
    queryKey: confirmationKeys.queue,
    queryFn: () => dealConfirmation.queue(),
    // A manager leaves the Intake page open; new submissions should show.
    refetchInterval: 60_000,
    retry: false,
  })
  const [open, setOpen] = useState(false)
  const [deal, setDeal] = useState<string | null>(null)
  const data = queue.data
  if (!data?.enabled || !data.canApprove) return null

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 rounded border border-amber-300/30 px-2 py-1 text-[10px] uppercase tracking-wide text-amber-200 hover:bg-amber-300/10"
      >
        <Users className="h-3 w-3" aria-hidden="true" />
        Manager queue
        {data.waiting.length > 0 ? (
          <span className="rounded-full bg-amber-400/20 px-1.5 py-px text-[9px] font-semibold tabular-nums text-amber-200">
            {data.waiting.length}
          </span>
        ) : null}
      </button>
      {open ? (
        <ConfirmationViewQueueDialog onClose={() => setOpen(false)} onOpenDeal={(id) => setDeal(id)} />
      ) : null}
      {deal ? <ConfirmationViewDialog loanId={deal} zIndex={170} onClose={() => setDeal(null)} /> : null}
    </>
  )
}
